import { render, staticRenderFns } from "./resource-categories-view.vue?vue&type=template&id=26980a69&"
import script from "./resource-categories-view.vue?vue&type=script&lang=js&"
export * from "./resource-categories-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports